import { Component } from "react"

/* Widgets */
import RoundView from "../Round/RoundView"

/* Registry */
import { vipThreeBox } from "../Round/registry"


/* Widget GameInformation — THE ROUND OF A VIP THREE BOX TABLE, ONE PLAYER PER BOX */
class GameInformation extends Component {

    render = () => {

        /* Fields */
        const { uid, gameID, postfix, socket } = this.props

        return <RoundView api={vipThreeBox.api} config={vipThreeBox} uid={uid} gameID={gameID} postfix={postfix} socket={socket} />
    }

}

export default GameInformation
